// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15 12H19.5L12 2L4.5 12H9V22H15V12Z"}}]};

const ArrowTriangleUpFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'arrow-triangle-up-filled',
    ref,
    icon: element,
  },
));

ArrowTriangleUpFilledIcon.displayName = 'ArrowTriangleUpFilledIcon';

export default ArrowTriangleUpFilledIcon;
